<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row align-items-center">
        <div class="col-11">
          <div class="breadcrumb-container">
            <template v-if="p_idAtencion !== 0">
              <router-link to="/atencion">Atenciones</router-link>
              &rsaquo;
              <router-link
                :to="{
                  name: 'AtencionForm',
                  state: { idAtencion: p_idAtencion }
                }"
              >
                Atención {{ p_numero }}
              </router-link>
              &rsaquo; Vacunas
            </template>
            <template v-else>
              <router-link to="/persona">Personas</router-link>
              &rsaquo;
              <router-link :to="{
                name: 'PersonaForm',
                state: {
                  pagina:    p_pagina,
                  idPersona: p_idPersona,
                }
              }">
                {{ datoPersona.nombreCompleto }}
              </router-link>
              &rsaquo; Vacunas
            </template>
          </div>
        </div>
        <div class="col-1 text-end">
          <button class="btn-help" type="button" title="Abrir ayuda"
            @click="showModalHelp = true"
            aria-label="Abrir ayuda de vacunas">
            <span class="material-symbols-outlined">help</span>
          </button>
        </div>
      </div>
    </div>

    <hr />

    <Modal v-model:modelValue="showModalHelp" title="Ayuda — Vacunas del Paciente">
      <AyudaVacunaPers />
    </Modal>

    <!-- Bloque: Datos del Paciente -->
    <div class="d-flex justify-content-between align-items-center mb-2">
      <b>Datos del Paciente</b>
      <button class="btn btn-link p-0 text-decoration-none"
        @click.prevent="mostrarBloque = !mostrarBloque">
        <span class="material-symbols-outlined align-middle">
          {{ mostrarBloque ? 'expand_less' : 'expand_more' }}
        </span>
        {{ mostrarBloque ? 'Mostrar menos' : 'Mostrar más información' }}
      </button>
    </div>

    <div class="form-card mb-3">
      <div class="mb-3">
        <div class="row align-items-center">
          <div class="col-7">
            <label class="col-form-label">Nombre</label>
            <input type="text" class="form-control" v-model="datoPersona.nombreCompleto" disabled />
          </div>
          <div class="col-3">
            <label class="col-form-label">{{ datoPersona.tipoIdenNombre }}</label>
            <input type="text" class="form-control" v-model="datoPersona.documento" disabled />
          </div>
        </div>
      </div>

      <!-- Sección colapsable -->
      <div v-if="mostrarBloque">
        <hr class="my-2" />
        <div class="mb-3">
          <div class="row align-items-center">
            <div class="col-2"><label class="col-form-label">Email</label></div>
            <div class="col-6">
              <input type="text" class="form-control" v-model="datoPersona.email" disabled />
            </div>
            <div class="col-2"><label class="col-form-label">Estado Civil</label></div>
            <div class="col-2">
              <input type="text" class="form-control" v-model="datoPersona.estadoCivilNombre" disabled />
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row align-items-center">
            <div class="col-2"><label class="col-form-label">Localidad</label></div>
            <div class="col-6">
              <input type="text" class="form-control" v-model="datoPersona.localidadNombre" disabled />
            </div>
            <div class="col-2"><label class="col-form-label">Teléfono</label></div>
            <div class="col-2">
              <input type="text" class="form-control" v-model="datoPersona.telefono" disabled />
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-2"><label class="col-form-label">Primer Nombre</label></div>
            <div class="col-4">
              <input type="text" class="form-control" v-model="datoPersona.primerNombre" disabled />
            </div>
            <div class="col-2"><label class="col-form-label">Segundo Nombre</label></div>
            <div class="col-4">
              <input type="text" class="form-control" v-model="datoPersona.segundoNombre" disabled />
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-2"><label class="col-form-label">Primer Apellido</label></div>
            <div class="col-4">
              <input type="text" class="form-control" v-model="datoPersona.primerApellido" disabled />
            </div>
            <div class="col-2"><label class="col-form-label">Segundo Apellido</label></div>
            <div class="col-4">
              <input type="text" class="form-control" v-model="datoPersona.segundoApellido" disabled />
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-2"><label class="col-form-label">Fecha de Nacimiento</label></div>
            <div class="col-4">
              <input type="text" class="form-control"
                :value="getFormattedDate(datoPersona.fechaNac)" disabled />
            </div>
            <div class="col-2"><label class="col-form-label">Sexo</label></div>
            <div class="col-4">
              <input type="text" class="form-control" :value="sexoDecodificado" disabled />
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-12">
              <label class="col-form-label">Dirección</label>
              <input type="text" class="form-control" v-model="datoPersona.direccion" disabled />
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row g-2">
            <div class="col-6 col-md-2">
              <label class="form-label">Id. Persona</label>
              <input type="text" class="form-control form-control-sm" v-model="datoPersona.idPersona" disabled />
            </div>
            <div class="col-6 col-md-2">
              <label class="form-label">Id. Empresa</label>
              <input type="text" class="form-control form-control-sm" v-model="datoPersona.idEmpresa" disabled />
            </div>
            <div class="col-6 col-md-2">
              <label class="form-label">Usuario Reg.</label>
              <input type="text" class="form-control form-control-sm" v-model="datoPersona.idUsuarioReg" disabled />
            </div>
            <div class="col-6 col-md-2">
              <label class="form-label">Fecha Reg.</label>
              <input type="text" class="form-control form-control-sm"
                :value="getFormattedDate(datoPersona.fechaReg)" disabled />
            </div>
            <div class="col-6 col-md-2">
              <label class="form-label">Usuario Act.</label>
              <input type="text" class="form-control form-control-sm" v-model="datoPersona.idUsuarioAct" disabled />
            </div>
            <div class="col-6 col-md-2">
              <label class="form-label">Fecha Act.</label>
              <input type="text" class="form-control form-control-sm" v-model="datoPersona.fechaAct" disabled />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DataTable de Vacunas -->
    <DataTable
      :data="vacunaperssFiltered"
      :columns="columnasVacuna"
      idField="idVacunaPers"
      :mostrarBotonTodos="true"
      :mostrarBotonNuevo="true"
      :mostrarBotonExcel="true"
      :mostrarInfo="false"
      :mostrarEditar="true"
      :mostrarVer="false"
      :mostrarEliminar="false"
      mensajeVacio="No hay vacunas registradas."
      @refresh="getDataTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idVacunaPers)"
    >
      <template #acciones-extra>
        <div class="col-auto">
          <button class="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
            @click="registrarVacunasRecomendadas" title="Registro de Vacunas Recomendadas">
            <span class="material-symbols-outlined" style="font-size:16px">vaccines</span>
            Recomendadas
          </button>
        </div>
        <div class="col-auto">
          <button class="btn btn-outline-success btn-sm d-flex align-items-center gap-1"
            @click="tablaPersona" title="Ver tabla">
            <span class="material-symbols-outlined" style="font-size:16px">table</span>
            Tabla
          </button>
        </div>
        <div class="col-auto d-flex align-items-center gap-2">
          <label class="small fw-bold mb-0">Vacuna</label>
          <select v-model="filtroVacuna" class="form-select form-select-sm" style="min-width:160px">
            <option value="">Todas</option>
            <option v-for="v in vacunas" :key="v.idVacuna" :value="v.nombre">{{ v.nombre }}</option>
          </select>
        </div>
      </template>
    </DataTable>

    <!-- Modal Vacuna -->
    <Teleport to="body">
      <div class="modal fade" id="ventanaModal" tabindex="-1"
        aria-labelledby="modalVacunaLabel" aria-hidden="true" ref="modalRef">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title" id="modalVacunaLabel">
                <span class="material-symbols-outlined align-middle me-2" style="font-size:20px">
                  {{ btnCrear_det ? 'add_circle' : 'edit' }}
                </span>
                {{ titulo }}
              </h5>
              <button type="button" class="btn-close btn-close-white"
                @click="cerrarModal" aria-label="Cerrar"></button>
            </div>

            <div class="modal-body">
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-2"><label class="col-form-label">Vacuna</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoVacunaPers.idVacuna">
                      <option v-for="v in vacunas" :value="v.idVacuna" :key="v.idVacuna">
                        {{ v.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-2"><label class="col-form-label">Vacuna Prod.</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoVacunaPers.idVacunaProd">
                      <option v-for="vp in vacunaProds" :value="vp.idVacunaProd" :key="vp.idVacunaProd">
                        {{ vp.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-2"><label class="col-form-label">Fecha Aplicación</label></div>
                  <div class="col-10">
                    <input type="date" class="form-control"
                      v-model="formattedFechaNac"
                      :min="minDate"
                      :max="maxDate"
                      required />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-2"><label class="col-form-label">Observación</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control"
                      v-model="datoVacunaPers.observacion"
                      style="text-transform:uppercase" required />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-2"><label class="col-form-label">Lote</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control"
                      v-model="datoVacunaPers.lote"
                      style="text-transform:uppercase" required />
                  </div>
                </div>
              </div>

              <!-- Sección colapsable del modal -->
              <div class="d-flex justify-content-between align-items-center">
                <button class="btn btn-link p-0 text-decoration-none"
                  @click.prevent="mostrarBloque02 = !mostrarBloque02">
                  <span class="material-symbols-outlined align-middle">
                    {{ mostrarBloque02 ? 'expand_less' : 'expand_more' }}
                  </span>
                  {{ mostrarBloque02 ? 'Mostrar menos' : 'Mostrar más información' }}
                </button>
              </div>
              <div v-if="mostrarBloque02">
                <hr class="my-2" />
                <div class="mb-3">
                  <div class="row align-items-center">
                    <div class="col-2"><label class="col-form-label">Id. VacunaPers</label></div>
                    <div class="col-10">
                      <input type="text" class="form-control" v-model="datoVacunaPers.idVacunaPers" disabled />
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row align-items-center">
                    <div class="col-2"><label class="col-form-label">Id. Persona</label></div>
                    <div class="col-10">
                      <input type="text" class="form-control" v-model="datoVacunaPers.idPersona" disabled />
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2"><label class="col-form-label">Usuario Reg.</label></div>
                    <div class="col-4">
                      <input type="text" class="form-control" v-model="datoVacunaPers.idUsuarioReg" disabled />
                    </div>
                    <div class="col-2"><label class="col-form-label">Fecha Reg.</label></div>
                    <div class="col-4">
                      <input type="text" class="form-control" v-model="datoVacunaPers.fechaReg" disabled />
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2"><label class="col-form-label">Usuario Act.</label></div>
                    <div class="col-4">
                      <input type="text" class="form-control" v-model="datoVacunaPers.idUsuarioAct" disabled />
                    </div>
                    <div class="col-2"><label class="col-form-label">Fecha Act.</label></div>
                    <div class="col-4">
                      <input type="text" class="form-control" v-model="datoVacunaPers.fechaAct" disabled />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-secondary btn-sm" @click="cerrarModal">
                <span class="material-symbols-outlined align-middle" style="font-size:18px">close</span>
                Cancelar
              </button>
              <button v-if="btnCrear_det" class="btn btn-success btn-sm"
                @click.prevent="guardarVacunaPers">
                <span class="material-symbols-outlined align-middle" style="font-size:18px">save</span>
                Guardar
              </button>
              <button v-if="btnEditar_det" class="btn btn-primary btn-sm"
                @click.prevent="guardarEditVacunaPers">
                <span class="material-symbols-outlined align-middle" style="font-size:18px">update</span>
                Actualizar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <Footer />
  </div>
</template>

<script>
import Layout          from '@/components/Layout.vue'
import Footer          from '@/components/Footer.vue'
import DataTable       from '@/components/DataTable.vue'
import AyudaVacunaPers from '@/views/ayuda/AyudaVacunaPers.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat      from '@/modules/dateFormat.js'
import api             from '@/services/api'
import { Modal }       from 'bootstrap'
import Swal            from 'sweetalert2'

export default {
  name: 'VacunaPers',
  components: { Layout, Footer, DataTable, AyudaVacunaPers },

  props: {
    p_pagina:         { type: String, required: true },
    p_idAtencion:     { type: Number, required: true },
    p_estadoAtencion: { type: String, required: true },
    p_numero:         { type: String, required: true },
    p_idPersona:      { type: Number, required: true },
    p_edad:           { type: Number, required: true },
  },

  data() {
    return {
      datoPersona:     {},
      mostrarBloque:   false,
      mostrarBloque02: false,
      showModalHelp:   false,
      vacunaperss:     [],
      datoVacunaPers:  {},
      titulo:          '',
      btnCrear_det:    false,
      btnEditar_det:   false,
      modalInstance:   null,
      vacunas:         [],
      vacunaProds:     [],
      filtroVacuna:    '',
      columnasVacuna: [
        { field: 'vacunaNombre',     label: 'Nombre' },
        { field: 'fechaApli',        label: 'Fecha Aplicación', format: (val) => dateFormat.getFormattedDate(val) },
        { field: 'observacion',      label: 'Observación' },
        { field: 'vacunaProdNombre', label: 'Producto' },
        { field: 'lote',             label: 'Lote' },
      ],
    }
  },

  watch: {
    'datoVacunaPers.idVacuna'(newIdVacuna) {
      if (newIdVacuna) this.fetchVacunaProds(newIdVacuna)
    },
  },

  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)
    },
    formattedFechaNac: {
      get() {
        if (!this.datoVacunaPers.fechaApli) return ''
        const date  = new Date(this.datoVacunaPers.fechaApli)
        const year  = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day   = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      },
      set(value) {
        const date = new Date(value)
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset())
        this.datoVacunaPers.fechaApli = date.toISOString()
      },
    },
    vacunaperssFiltered() {
      if (!this.filtroVacuna) return this.vacunaperss
      return this.vacunaperss.filter(v => v.vacunaNombre === this.filtroVacuna)
    },
    sexoDecodificado() {
      const s = this.datoPersona.sexo
      if (s === 'M') return 'Masculino'
      if (s === 'F') return 'Femenino'
      return s || ''
    },
    minDate() {
      return this.formatDate(this.datoPersona.fechaNac)
    },
    maxDate() {
      return new Date().toISOString().split('T')[0]
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.cargarPersona()
    this.getDataTodos()
    this.fetchVacunas()
    this.$nextTick(() => {
      if (this.$refs.modalRef) {
        this.modalInstance = new Modal(this.$refs.modalRef)
      }
    })
  },

  beforeUnmount() {
    if (this.modalInstance) this.modalInstance.dispose()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },
    formatDate(date) {
      if (!date) return ''
      const d     = new Date(date)
      const year  = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day   = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    // ── Persona ───────────────────────────────────────────────────────────
    async cargarPersona() {
      try {
        const resp = await api.get(`/vwpersonas/${this.p_idPersona}`)
        this.datoPersona = resp.data
      } catch (err) {
        console.error('Error cargando persona:', err)
      }
    },

    // ── Vacunas ───────────────────────────────────────────────────────────
    async getDataTodos() {
      try {
        const resp = await api.get(`/vwvacunaperss/idpersona/${this.p_idPersona}`)
        this.vacunaperss = resp.data.reverse()
      } catch (err) {
        console.error('Error cargando vacunas:', err)
      }
    },

    validarFormDet() {
      return validarForm(
        this.datoVacunaPers,
        ['idVacuna', 'fechaApli'],
        ['Vacuna', 'Fecha de aplicación']
      )
    },

    abrirModalCrear() {
      this.datoVacunaPers  = {}
      this.titulo          = 'Nuevo Registro'
      this.btnCrear_det    = true
      this.btnEditar_det   = false
      this.mostrarBloque02 = false
      this.modalInstance?.show()
    },

    async abrirModalEditar(idVacunaPers) {
      this.titulo          = 'Editar Registro'
      this.btnCrear_det    = false
      this.btnEditar_det   = true
      this.mostrarBloque02 = false
      try {
        const resp = await api.get(`/vwvacunaperss/${idVacunaPers}`)
        this.datoVacunaPers = resp.data
      } catch (err) {
        console.error('Error cargando vacuna:', err)
      }
      this.modalInstance?.show()
    },

    cerrarModal() {
      this.modalInstance?.hide()
    },

    async guardarVacunaPers() {
      if (this.validarFormDet() !== 1) return
      try {
        this.datoVacunaPers.idPersona    = this.datoPersona.idPersona
        this.datoVacunaPers.idUsuarioReg = window.sessionStorage.getItem('idUsuario')
        await api.post('/vacunaperss', this.datoVacunaPers)
        this.cerrarModal()
        await Swal.fire({ icon: 'success', title: '¡Correcto!', text: 'Vacuna registrada exitosamente.', timer: 2000, showConfirmButton: false })
        this.getDataTodos()
      } catch {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Inténtelo de nuevo.' })
      }
    },

    async guardarEditVacunaPers() {
      if (this.validarFormDet() !== 1) return
      try {
        await api.post('/vacunaperss', this.datoVacunaPers)
        this.cerrarModal()
        await Swal.fire({ icon: 'success', title: '¡Correcto!', text: 'Vacuna actualizada exitosamente.', timer: 2000, showConfirmButton: false })
        this.getDataTodos()
      } catch {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Inténtelo de nuevo.' })
      }
    },

    // ── Catálogos ─────────────────────────────────────────────────────────
    fetchVacunas() {
      api.get('/vwvacunas')
        .then(r => { this.vacunas = r.data })
        .catch(e => console.error('Error cargando vacunas:', e))
    },
    fetchVacunaProds(idVacuna) {
      api.get(`/vwvacunaprods/idvacuna/${idVacuna}`)
        .then(r => { this.vacunaProds = r.data })
        .catch(e => console.error('Error cargando productos de vacuna:', e))
    },

    // ── Acciones especiales ───────────────────────────────────────────────
    async registrarVacunasRecomendadas() {
      const idPersona    = this.p_idPersona
      const idUsuarioReg = window.sessionStorage.getItem('idUsuario')
      if (!idPersona || !idUsuarioReg) {
        Swal.fire({ icon: 'warning', title: 'Parámetros faltantes',
          text: 'Asegúrese de que idPersona e idUsuarioReg están presentes.' })
        return
      }
      try {
        const response = await api.post(`/vacunaperss/registrar-iniciales/${idPersona}/${idUsuarioReg}`)
        this.getDataTodos()
        Swal.fire({ icon: 'success', title: 'Registro Exitoso',
          text: response.data.message || 'Vacunas recomendadas registradas exitosamente.' })
      } catch (error) {
        Swal.fire({ icon: 'error', title: 'Error',
          text: 'Error al registrar vacunas: ' + (error.response?.data?.message || error.message) })
      }
    },

tablaPersona() {
  let routeName;
  if      (this.p_edad <= 5)                     routeName = 'VacunaPersTabla01';
  else if (this.p_edad > 5 && this.p_edad <= 18) routeName = 'VacunaPersTabla02';
  else                                           routeName = 'VacunaPersTabla03';

  this.$router.push({
    name: routeName,
    state: {
      idPersona:  this.p_idPersona,
      idAtencion: this.p_idAtencion,
      numero:     this.p_numero,
      edad:       this.p_edad,
    }
  });
},
  },
}
</script>

<style scoped>
.btn-help {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #0d6efd;
}
.btn-help .material-symbols-outlined {
  font-size: 32px;
  transition: color 0.2s;
}
.btn-help:hover .material-symbols-outlined {
  color: #0a58ca;
}
</style>
<style src="@/assets/css/interruptor.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>